import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import api from '../../axios-local-api';
import Confirm from '../../components/UI/Confirm/Confirm';
import Error from '../../components/UI/Error/Error';
import Modal from '../../components/UI/Modal/Modal';
import Spinner from '../../components/UI/Spinner/Spinner';
import Success from '../../components/UI/Success/Success';
import Box from '../../hoc/Box/Box';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../store/actions/index';
import classes from './DNSServer.css';

export class DNSServer extends Component {
  constructor(props) {
    super(props);
    this.dnsBtn = true;
    this.state = {
      upArrows: false,
      action: null,
      success: false,
      error: false,
      originalPrimaryDns: this.props.originalPrimaryDns,
      originalSecondaryDns: this.props.originalSecondaryDns,
      controls: {
        primaryDns: {
          elementType: 'input',
          elementConfig: {
            type: 'PrimaryDns',
            placeholder: 'Primary DNS',
          },
          value: this.props.realDns.primaryDns
            ? this.props.realDns.primaryDns
            : this.props.originalPrimaryDns,
          validation: {
            required: true,
            minLength: 7,
          },
          valid: false,
          touched: false,
        },
        secondaryDns: {
          elementType: 'input',
          elementConfig: {
            type: 'secondaryDns',
            placeholder: 'Secondary DNS',
          },
          value: this.props.realDns.secondaryDns
            ? this.props.realDns.secondaryDns === undefined
              ? ''
              : this.props.realDns.secondaryDns
            : this.props.originalSecondaryDns,
          validation: {
            required: true,
            minLength: 7,
          },
          valid: false,
          touched: false,
        },
      },
    };
  }

  openHandler() {
    this.setState({
      upArrows: true,
    });
  }
  closeHandler() {
    this.setState({
      upArrows: false,
    });
  }
  successErrorResetHandler = () => {
    this.setState({ error: false, success: false });
    this.props.onResetDnsErrorSuccess();
  };
  confirmModalConfirmHandler = () => {
    if (this.state.action === 'change DNS settings') {
      this.props.onChangeDns(
        this.state.controls.primaryDns.value,
        this.state.controls.secondaryDns.value,
        true
      );
      this.confirmModalCancelHandler();
    }
    if (this.state.action === 'reset DNS to default settings') {
      this.props.onChangeDns('', '', false);
      this.confirmModalCancelHandler();
    }
  };
  confirmModalCancelHandler = () => {
    this.setState({ confirmModal: false });
  };
  onOpenModal = (action) => {
    this.setState({
      confirmModal: true,
      action: action,
    });
  };

  handlePrimaryDnsChange = (e) => {
    let myValue = e.target.value;
    let OrginalValue = this.props.realDns.primaryDns ? this.props.realDns.primaryDns : this.props.originalPrimaryDns;
    if (OrginalValue === myValue) {
      this.dnsBtn = true;
    } else {
      this.dnsBtn = false;
    }
    this.setState((prevState) => ({
      ...prevState,
      controls: {
        ...prevState.controls,
        primaryDns: {
          ...prevState.controls.primaryDns,
          value: myValue,
        },
      },
    }));
  };
  handleSecondaryDnsChange = (e) => {
    let myValue = e.target.value;
    let OrginalValue = this.props.realDns.secondaryDns ? this.props.realDns.secondaryDns === undefined ? '' : this.props.realDns.secondaryDns : this.props.originalSecondaryDns;
    if (OrginalValue === myValue) {
      this.dnsBtn = true;
    } else {
      this.dnsBtn = false;
    }

    this.setState((prevState) => ({
      ...prevState,
      controls: {
        ...prevState.controls,
        secondaryDns: {
          ...prevState.controls.secondaryDns,
          value: myValue,
        },
      },
    }));
  };
  submitDnsHandler = (event) => {
    this.onOpenModal('change DNS settings');
  };
  defaultDnsHandler = (event) => {
    this.onOpenModal('reset DNS to default settings');
  };
  render() {
    if (this.props.error && !this.state.error) {
      this.setState({ error: true });
      this.props.onResetDnsErrorSuccess();
    }
    if (this.props.success && !this.state.success) {
      this.setState({ success: true });
      this.props.onResetDnsErrorSuccess();
    }
    let arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (this.state.upArrows) {
      arrow = (
        <MdKeyboardArrowUp aria-label="arrow up" color={'gray'} size={'30px'} />
      );
    } else {
      arrow = (
        <MdKeyboardArrowDown
          aria-label="arrow down"
          color={'gray'}
          size={'30px'}
        />
      );
    }
    if (this.props.realDns === null) {
      return <Spinner />;
    } else {
      return (
        <Box>
          <div className={[classes.showDesktop, classes.DNSServer].join(' ')}>
            <div className={classes.TitleArea}>
              <b id="ManageDNS"> Manage DNS Server</b>
            </div>
            <div className={classes.Separator} />
            <div className={classes.BodyArea} style={{ overflowX: 'scroll' }}>
              <div className={classes.InputContainer}>
                <div className={classes.InputColumn}>
                  <div>Primary DNS Server</div>
                  <input
                    type="text"
                    id="primaryDNSpass"
                    name="password"
                    aria-label="primary dns server"
                    minLength="7"
                    required
                    value={this.state.controls.primaryDns.value}
                    onChange={this.handlePrimaryDnsChange}
                    disabled={this.props?.realDns?.isMapT || this.props?.realDns?.isMapT === undefined ? true : false}
                  />
                </div>
                <div className={classes.InputColumn}>
                  <div>Secondary DNS Server</div>
                  <input
                    type="text"
                    id="SecondaryDNSpass"
                    name="password"
                    aria-label="secondary dns server"
                    placeholder={
                      this.props.realDns.secondaryDns
                        ? ''
                        : this.props.originalSecondaryDns === ''
                          ? 'N/A'
                          : ''
                    }
                    minLength="7"
                    required
                    value={this.state.controls.secondaryDns.value}
                    onChange={this.handleSecondaryDnsChange}
                    disabled={this.props?.realDns?.isMapT || this.props?.realDns?.isMapT === undefined ? true : false}
                  />
                </div>
                <div className={classes.InputColumn}>
                  <button
                    id="saveDNSfields"
                    style={{ marginLeft: '10px' }}
                    className={classes.ResetPassButton}
                    title="Change DNS"
                    onClick={this.submitDnsHandler}
                    disabled={
                      this.dnsBtn ||
                      (this.state.controls.primaryDns.value === this.state.originalPrimaryDns &&
                        this.state.controls.secondaryDns.value === this.state.originalSecondaryDns) ||
                      this.state.controls.primaryDns.value === this.state.controls.secondaryDns.value ||
                      (this.state.controls.primaryDns.value.length === 0 &&
                        this.state.controls.secondaryDns.value.length >= 1 &&
                        this.state.controls.secondaryDns.value.match(
                          /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
                        )) ||
                      (this.state.controls.primaryDns.value.length >= 1 &&
                        !this.state.controls.primaryDns.value.match(
                          /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
                        )) ||
                      (this.state.controls.secondaryDns.value.length >= 1 &&
                        !this.state.controls.secondaryDns.value.match(
                          /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
                        )) ||
                      this.state.controls.primaryDns.value === '255.255.255.255' ||
                      this.state.controls.secondaryDns.value === '255.255.255.255'
                    }
                  >
                    Save
                  </button>
                </div>
              </div>
              <div className={classes.InputContainer}>
                <button
                  id="dnsreset"
                  className={classes.RegularButton}
                  onClick={this.defaultDnsHandler}
                  disabled={!this.props.realDns.enabled}
                >
                  Reset to Default
                </button>
              </div>
            </div>
          </div>

          <div className={[classes.showMobile, classes.DNSServer].join(' ')}>
            <Collapsible
              transitionTime={100}
              onOpening={() => {
                this.openHandler();
              }}
              onClosing={() => {
                this.closeHandler();
              }}
              trigger={
                <Box>
                  <div>
                    <div className={classes.TitleArea}>
                      <div className={classes.TitleLeft}>
                        <h3>Manage DNS Server</h3>
                      </div>
                      <button className={classes.OpenCloseButton}>
                        {arrow}
                      </button>
                    </div>
                  </div>
                  <div className={classes.Separator} />
                </Box>
              }
            >
              <div className={classes.BodyArea} style={{ overflowX: 'scroll' }}>
                <div className={classes.InputContainer}>
                  <div className={classes.InputColumn}>
                    <div>Primary DNS Server</div>
                    <input
                      type="text"
                      id="primaryDNSpass"
                      name="password"
                      aria-label="primary dns server"
                      minLength="7"
                      required
                      value={this.state.controls.primaryDns.value}
                      onChange={this.handlePrimaryDnsChange}
                    />
                  </div>
                  <div className={classes.InputColumn}>
                    <div>Secondary DNS Server</div>
                    <input
                      type="text"
                      id="SecondaryDNSpass"
                      name="password"
                      aria-label="secondary dns server"
                      placeholder={
                        this.props.realDns.secondaryDns
                          ? ''
                          : this.props.originalSecondaryDns === ''
                            ? 'N/A'
                            : ''
                      }
                      minLength="7"
                      required
                      value={this.state.controls.secondaryDns.value}
                      onChange={this.handleSecondaryDnsChange}
                    />
                  </div>
                  <div className={classes.InputColumn}>
                    <button
                      id="saveDNSfields"
                      className={classes.ResetPassButton}
                      title="Change DNS"
                      onClick={this.submitDnsHandler}
                      disabled={
                        this.dnsBtn ||
                        (this.state.controls.primaryDns.value === this.state.originalPrimaryDns &&
                          this.state.controls.secondaryDns.value === this.state.originalSecondaryDns) ||
                        this.state.controls.primaryDns.value === this.state.controls.secondaryDns.value ||
                        (this.state.controls.primaryDns.value.length === 0 &&
                          this.state.controls.secondaryDns.value.length >= 1 &&
                          this.state.controls.secondaryDns.value.match(
                            /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
                          )) ||
                        (this.state.controls.primaryDns.value.length >= 1 &&
                          !this.state.controls.primaryDns.value.match(
                            /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
                          )) ||
                        (this.state.controls.secondaryDns.value.length >= 1 &&
                          !this.state.controls.secondaryDns.value.match(
                            /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
                          )) ||
                        this.state.controls.primaryDns.value === '255.255.255.255' ||
                        this.state.controls.secondaryDns.value === '255.255.255.255'
                      }

                    >
                      Save
                    </button>
                  </div>
                </div>
                <div className={classes.InputContainer}>
                  <button
                    className={classes.RegularButton}
                    onClick={this.defaultDnsHandler}
                    disabled={!this.props.realDns.enabled}
                  >
                    Reset to Default
                  </button>
                </div>
              </div>
            </Collapsible>
          </div>
          <Modal
            show={this.state.confirmModal}
            modalClosed={this.confirmModalCancelHandler}
          >
            <Confirm
              id="DNSConfirm"
              action={`Are you sure you want to ${this.state.action}?`}
              confirm={this.confirmModalConfirmHandler}
              cancel={this.confirmModalCancelHandler}
              deviceGroupConfirmation
            />
          </Modal>
          <Modal
            show={this.state.error}
            modalClosed={this.successErrorResetHandler}
          >
            <Error id={'DNSServerError'} errorStatus={this.props.errorStatus} showOldView/>
          </Modal>
          <Modal
            show={this.state.success}
            modalClosed={this.successErrorResetHandler}
          >
            <Success id={'DNSServerSuccess'} />
          </Modal>
        </Box>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.dns.loading,
    loaded: state.dns.loaded,
    account: state.settings.account,
    isAuthenticated: state.auth.token !== null,
    isPinxt: state.auth.pToken !== null,
    realSettings: state.settings.realSettings,
    isDummy: state.auth.isDummy,
    realDns: state.dns.realDns,
    success: state.dns.success,
    error: state.dns.error,
    errorStatus: state.dns.errorStatus
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChangeDns: (primary, secondary, enabled) =>
      dispatch(actions.changeDns(primary, secondary, enabled)),
    onResetDnsErrorSuccess: () => dispatch(actions.resetDnsErrorSuccess()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(DNSServer, api));
